/**
 * A save refused because the studio moved on (optimistic concurrency: the
 * edit was made from version N, someone saved N+1). Two ways on: load their
 * version (the edit is discarded), or keep the edit and save it on top of
 * theirs — which replaces their change, so the dialog says whose it is.
 */
import { Button } from '../ui/button.js';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog.js';

export type StudioConflictDialogProps = {
  readonly open: boolean;
  readonly mine: number;
  readonly theirs: { readonly version: number; readonly updatedBy: string; readonly updatedAt: string };
  readonly onLoadTheirs: () => void;
  readonly onKeepMine: () => void;
  readonly onCancel: () => void;
};

export function StudioConflictDialog({ open, mine, theirs, onLoadTheirs, onKeepMine, onCancel }: StudioConflictDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
    >
      <DialogContent data-testid="studio-conflict-dialog">
        <DialogHeader>
          <DialogTitle>The studio changed while you edited</DialogTitle>
          <DialogDescription>
            You edited version {mine}; {theirs.updatedBy} saved version {theirs.version} ({theirs.updatedAt}). Load theirs and discard your edit, or save yours over theirs.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onLoadTheirs} data-testid="conflict-load-theirs">
            Load version {theirs.version}
          </Button>
          <Button variant="destructive" onClick={onKeepMine} data-testid="conflict-keep-mine">
            Save mine over it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
